export enum OrderFlowTypesEnum {
  NEW_ORDER = 'NEW_ORDER',
  EARLY_UPGRADE = 'EARLY_UPGRADE',
  UPGRADE = 'UPGRADE',
  PROLONG = 'PROLONG',
}
